import axios from 'axios';

const request = host => axios.create({
  baseURL: host,
  timeout: 10000,
});

export default request;